export class Contact {
    _id: string;
    id: string;
    name:string;
    phone:string;
    email:string;
    socailmedia:string;
    notes:string;
    admin_notes:string;
    landmark:string;
    address:string;
    lat:number;
    lng:number;
  
}

